import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from './contexts';
import { IdleStateProvider } from './contexts/IdleStateContext';
import { ConfigurationErrorBoundary } from './components/common/ConfigurationErrorBoundary';
import { shouldBypassAuth } from './lib/config';
import '@cloudscape-design/global-styles/index.css';
import './theme/ttec-theme.css';
import './styles/responsive.css';
import './styles/accessibility.css';

function App() {
  return (
    <ConfigurationErrorBoundary>
      <AuthProvider bypassAuth={shouldBypassAuth()}>
        <IdleStateProvider>
          <RouterProvider router={router} />
        </IdleStateProvider>
      </AuthProvider>
    </ConfigurationErrorBoundary>
  );
}

export default App;
